module.exports = __webpack_public_path__ + "img/Engagement.f803a373.svg";